import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1448647400207767'

export function useMetaPixel() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Set up fbq queue function
      if (!window.fbq) {
        const n: any = (window.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        })
        window._fbq = n
        n.push = n
        n.loaded = true
        n.version = '2.0'
        n.queue = []

        // Load the pixel script safely
        try {
          const t = document.createElement('script')
          t.async = true
          t.src = 'https://connect.facebook.net/en_US/fbevents.js'
          document.head.appendChild(t)
        } catch (e) {
          // Silently fail if script injection isn't possible
        }
      }

      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackAddToCart = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart')
    }
  }

  return { trackAddToCart }
}
